export default __webpack_public_path__ + "static/media/AZE.f02d3881.svg";